module.exports = __webpack_public_path__ + "img/Danie_O_1.f0dd6dea.jpg";